import { useContext } from 'react'
import { AccessContext } from '../providers/AccessProvider'

export const useAccess = () => {
  return useContext(AccessContext)
}
